import { defineNuxtPlugin } from "@nuxtjs/composition-api";

interface GTM {
  init(key: string): void;
  push(event: { event: string; [key: string]: unknown }): void;
}

declare module "vue/types/vue" {
  interface Vue {
    $gtm: GTM;
  }
}

declare module "@nuxt/types" {
  interface NuxtConfig {
    gtm?: {
      enabled?: boolean;
      debug?: boolean;
      id?: string;
      layer?: string;
      variables?: Record<string, string>;
      pageTracking?: boolean;
      pageViewEventName?: string;
      autoInit?: boolean;
      respectDoNotTrack?: boolean;
      scriptId?: string;
      scriptDefer?: boolean;
      scriptURL?: string;
      crossOrigin?: boolean;
      noscript?: boolean;
      noscriptId?: string;
      noscriptURL?: string;
    };
  }

  interface Context {
    $gtm: GTM;
  }
}

export default defineNuxtPlugin(({ $gtm, $config }, _inject) => {
  // Remove undefined config values from the query
  const queryPairs = Object.keys($config.gtm.variables ?? {})
    .filter((key) => $config.gtm.variables[key] !== undefined)
    .map((key) => [key, $config.gtm.variables[key]]);

  const query = new URLSearchParams(queryPairs);

  // hack until https://github.com/nuxt-community/gtm-module/issues/94
  $gtm.init(`${$config.gtm.id}&${query.toString()}`);
});
